/**
 * Single seam for full-page reloads, kept in its own module so tests can mock it
 * (`vi.mock('utils/reloadPage')`) instead of tampering with `window.location`:
 * jsdom marks Location members unforgeable, so both spying on `reload` and
 * replacing the object are unsupported and break across jsdom upgrades
 * (https://github.com/jsdom/jsdom/issues/3739).
 *
 * No-ops during SSR.
 */
export function reloadPage(): void {
    if (typeof window === 'undefined') {
        return;
    }
    window.location.reload();
}
